import { render, staticRenderFns } from "./SuitableResourcesV2.vue?vue&type=template&id=41d4bca6&scoped=true"
import script from "./SuitableResourcesV2.vue?vue&type=script&lang=ts"
export * from "./SuitableResourcesV2.vue?vue&type=script&lang=ts"
import style0 from "./SuitableResourcesV2.vue?vue&type=style&index=0&id=41d4bca6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d4bca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41d4bca6')) {
      api.createRecord('41d4bca6', component.options)
    } else {
      api.reload('41d4bca6', component.options)
    }
    module.hot.accept("./SuitableResourcesV2.vue?vue&type=template&id=41d4bca6&scoped=true", function () {
      api.rerender('41d4bca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/SuitableResourcesV2.vue"
export default component.exports